import React from 'react';
export const CFIconEyeOff2 = {
    alias: 'eye-off-2',
    defaultTitle: 'Eye Off',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M17.809 13.395a8.947 8.947 0 0 0 3.183-5.771 1 1 0 0 0-1.984-.249C18.568 10.867 15.556 13.5 12 13.5s-6.57-2.633-7.008-6.125a1 1 0 1 0-1.984.249 8.947 8.947 0 0 0 3.183 5.771l-2.312 2.312a1.003 1.003 0 0 0 0 1.414 1.003 1.003 0 0 0 1.414 0l2.603-2.603c.954.482 2.001.8 3.104.921V19c0 .55.45 1 1 1s1-.45 1-1v-3.561a9.062 9.062 0 0 0 3.103-.921l2.604 2.603a1.003 1.003 0 0 0 1.414 0 1.003 1.003 0 0 0 0-1.414l-2.312-2.312Z' }))),
};
